import {
  Button,
  Flex,
  Grid,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

import useErrors from "hooks/useErrors";
import { CModal, CModalBody, CModalFooter } from "@coreui/react";

const DashboardForm = ({
  onSubmit,
  onDelete,
  type = "create",
  initialValues = { name: "", description: "" },
}) => {
  const [modalCancelVisible, setModalCancelVisible] = useState(false);
  const [dashboardForm, setDashboardForm] = useState(initialValues);
  const [errors, setErrors] = useState({
    name: "",
    description: "",
  });
  const validateErrors = useErrors({
    name: "isRequired",
  });

  const onSubmitForm = () => {
    let hasErrors = false;

    Object.entries(dashboardForm).forEach((itemForm) => {
      const [name, value] = itemForm;
      const check = !!checkErrors(name, value);
      if (!hasErrors) hasErrors = check;
    });

    if (!hasErrors) onSubmit(dashboardForm);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setDashboardForm((prevSt) => ({
      ...prevSt,
      [name]: value,
    }));
    checkErrors(name, value);
  };

  const checkErrors = (name, value) => {
    const errorMessage = validateErrors(name, value);
    if (errorMessage)
      setErrors((prevErr) => ({ ...prevErr, [name]: errorMessage }));
    else setErrors((prevErr) => ({ ...prevErr, [name]: "" }));
    return errorMessage;
  };

  const resetFormValues = () => {
    setErrors({
      name: "",
      description: "",
    });
    setDashboardForm(initialValues);
  };

  useEffect(() => {
    setDashboardForm(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid rowGap="15px" columnGap="15px" padding="20px">
      <TextField
        name="name"
        label={
          <span>
            {strings.fields.name.label}
            <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
          </span>
        }
        value={dashboardForm.name}
        onChange={onChange}
        errorMessage={errors.name}
        hasError={!!errors.name}
      ></TextField>
      <TextAreaField
        name="description"
        label={strings.fields.description.label}
        value={dashboardForm.description}
        onChange={onChange}
        errorMessage={errors.description}
        hasError={!!errors.description}
      ></TextAreaField>
      <Flex justifyContent="space-between">
        <div>
          {type !== "create" && (
            <Button
              children={strings.fields.buttons.delete}
              variation="destructive"
              onClick={() => setModalCancelVisible(true)}
            ></Button>
          )}
        </div>
        <Flex>
          <Button
            children={strings.fields.buttons.reset}
            onClick={resetFormValues}
          ></Button>
          <Button
            children={
              type === "create"
                ? strings.fields.buttons.create
                : strings.fields.buttons.save
            }
            onClick={onSubmitForm}
            variation="primary"
            isDisabled={Object.values(errors).some((e) => !!e)}
          ></Button>
        </Flex>
      </Flex>
      <CModal
        alignment="center"
        visible={modalCancelVisible}
        onClose={() => setModalCancelVisible(false)}
        backdrop="static"
        portal={false}
      >
        <CModalBody>
          <b>
            {strings.formatString(strings.modal.confirmDeleteQuestion, {
              name: initialValues?.name,
            })}
          </b>
        </CModalBody>
        <CModalFooter>
          <Button size="small" onClick={() => setModalCancelVisible(false)}>
            {strings.modal.cancelButton}
          </Button>
          <Button size="small" variation="primary" onClick={onDelete}>
            {strings.modal.confirmButton}
          </Button>
        </CModalFooter>
      </CModal>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      name: {
        label: "Nombre",
      },
      description: {
        label: "Descripción",
      },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
        delete: "Eliminar Tablero",
      },
    },
    modal: {
      confirmDeleteQuestion: "¿Estás seguro de eliminar el tablero {name}?",
      cancelButton: "Cancelar",
      confirmButton: "Confirmar",
    },
  },
});

export default DashboardForm;
